import React from 'react'
import Confirm from 'views/confirm/confirm'

import { localize } from 'helpers/translator'

const GoogleSlidesLessonShareConfirm = props => (
	<Confirm
		btOne={localize('global_cancel')}
		btTwo={localize('googleSlides_shareConfirm_agreeBtn')}
		alertTitle={localize('googleSlides_shareConfirm_titleNew')}
		alertMessage={localize('googleSlides_shareConfirm_messageNew')}
		actionButtonType={0}
		actionOne={props.onCancel}
		actionTwo={props.onConfirm}
		closeAction={props.onCancel}
	/>
)

export default GoogleSlidesLessonShareConfirm
